import dotProp from 'dot-prop'
import { useCallback, useMemo, useState } from 'react'
import { debounce } from 'throttle-debounce'

const useTermSearch = (list = [], keys = []) => {
	const [query, updateQuery] = useState('')
	const getMatchedIndexes = (text, query) => {
		const re = new RegExp(query.toLowerCase(), 'gm')
		const indexPairs = []

		let result
		while (null !== (result = re.exec(text.toLowerCase()))) {
			indexPairs.push([result.index, result.index + query.length - 1])
		}

		return indexPairs
	}

	const searchMatches = useMemo(() => {
		if (!query) {
			return list
		}

		return list
			.map((listEle) => {
				const matchedIndexes = keys.reduce((acc, keysEle) => {
					const value = dotProp.get(listEle, keysEle)
					const matchedIndexesPos = getMatchedIndexes(
						value || '',
						query
					)

					if (matchedIndexesPos.length) {
						acc[keysEle] = matchedIndexesPos
					}

					return acc
				}, {})

				return {
					...listEle,
					$textHighlight: {
						matchedIndexes,
						query,
					},
				}
			})
			.filter(
				(ele) =>
					Object.keys(ele.$textHighlight.matchedIndexes).length !== 0
			)
	}, [keys, list, query])

	const setQuery = useCallback(
		(value) => debounce(100, updateQuery(value)),
		[]
	)

	const onSearch = useCallback((e) => setQuery(() => e.trim()), [setQuery])

	return {
		searchMatches,
		onSearch,
		setQuery,
		query,
	}
}

export default useTermSearch
